import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../../userStore";
import moment from "moment";
import FullScreenLoader from "../../components/FullScreenLoader";
import {
  useGetNotificationsQuery,
  useReadAsMarkMutation,
} from "../../redux/service/notifications_service";
import { usePusherContext } from "../../components/pusher_context";

function Notifications() {
  const pusherContext = usePusherContext();
  const user = getUser();
  const [notificationTypes, setNotificationType] = useState("all");
  const [notificationData, setNotificationData] = useState([]);
  const [selectedNotifi, setSelectedNotifi] = useState("0");
  const [selectedNotificationData, setSelectedNotificationData] = useState("0");
  const [markAsReadgLoading, setMarkAsReadgLoading] = useState(false);
  const { data, refetch,isLoading,isFetching  } = useGetNotificationsQuery({
    status: notificationTypes,
    type: "patient",
    skip_encounter: true 
  });
  const [markAsRead] = useReadAsMarkMutation()
  //({skip_encounter: true, page: 1,user_id:user.pid,status: "all",portal: patient});
  const hours = moment(selectedNotificationData?.Alert?.created).format("h");
  const minutes = moment(selectedNotificationData?.Alert?.created).format("mm");
  const formattedTime = `${hours}:${minutes}`;
  useEffect(() => {
    if(data?.data?.length>0){
      setSelectedNotificationData(data?.data[0] || []);
    }
  }, [data?.data]);

  useEffect(() => {
    if (pusherContext?.pusherData.notification) {
      refetch(notificationTypes);
      toast.info(pusherContext?.pusherData?.notification?.title);
    }
  }, [pusherContext?.pusherData.notification]);
  
  useEffect(() => {
    if(data?.data[0]?.Alert?.unread === 1 && notificationTypes === 'all'){
      markAsRead({alert_id: data?.data[0]?.Alert?.id, status: 0}).then((res)=>{
        if(res?.data?.code === 0){
          refetch()
        }
      })
    }
  }, [data?.data]);

  return (
    <>
      {(isLoading || isFetching || markAsReadgLoading)  && <FullScreenLoader />}
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="flex gap-5 items-center">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Notifications
          </h3>
        </div>
        <div className=" flex-shrink-0">
          <button
            className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            onClick={() => {
              refetch();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="mx-3 mt-4 flex">
        <button
          className={`py-2 px-6 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            notificationTypes === "all" && "bg-blue-500 text-white"
          }`}
          onClick={() => {
            setNotificationType("all");
            if (notificationTypes === "all") {
              refetch();
            }
          }}
        >
          {" "}
          All{" "}
        </button>
        <button
          className={`py-2 px-5 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            notificationTypes === "read" && "bg-blue-500 text-white"
          }`}
          onClick={() => {
            setNotificationType("read");
            if (notificationTypes === "read") {
              refetch();
            }
          }}
        >
          {" "}
          Read{" "}
        </button>
        <button
          className={`py-2 px-3 m-1 mb-2 border border-gray-400 rounded-md hover:bg-gray-300 ${
            notificationTypes === "unread" && "bg-blue-500 text-white"
          }`}
          onClick={() => {
            setNotificationType("unread");
            if (notificationTypes === "unread") {
              refetch();
            }
          }}
        >
          {" "}
          Unread{" "}
        </button>
      </div>
      {data?.data?.length > 0 ? (
        <div className="flex gap-4 p-3">
          <div className="w-[40%]">
            <div className="sm-max-popup-height overflow-auto">
              {data?.data?.map((v, k) => (
                <div
                  onClick={() => {
                    setMarkAsReadgLoading(true)
                    setSelectedNotifi(k);
                    setSelectedNotificationData(v);
                    if(v?.Alert?.unread === 1){
                      markAsRead({alert_id: v?.Alert?.id, status: 0}).then((res)=>{
                        if(res?.data?.code === 0){
                          refetch()
                        }
                        setMarkAsReadgLoading(false)})
                    }else{
                      setMarkAsReadgLoading(false)
                    }
                  }}
                  key={k}
                  //${v?.Alert?.unread === 1 && "bg-blue-300"}
                  className={`p-3 group block text-left ${v?.Alert?.unread === 1 ? "bg-blue-200 hover:bg-blue-300" : "hover:bg-gray-200"}   border-b border-gray-500 relative cursor-pointer`}
                >
                  <div className="flex gap-2">
                    {k === selectedNotifi && (
                      <i class="block mt-2 rounded-full w-3 h-3 border-2 bg-blue-600 border-blue-600">
                        {" "}
                        &nbsp;{" "}
                      </i>
                    )}
                    <h5 class=" text-lg font-bold text-gray-900">
                      {v?.Alert?.sender_name }&nbsp;
                    </h5>
                    <p class="text-sm font-normal text-gray-400 absolute top-4 right-2">
                      <span class="font-medium  text-center p-4">
                        {moment(v?.Alert?.created).format("l hh:mm A")}
                      </span>
                    </p>
                  </div>
                  {v?.Patient?.full_name && (
                    <p class={` text-gray-500 font-medium`}>
                      Patient:{" "}
                      <span className="text-base">{v?.Patient?.full_name}</span>{" "}
                      <span className="text-sm font-normal">
                        {v?.Alert?.message}
                      </span>
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
          {data?.data?.length > 0 && (
            <div className="w-[60%]">
              <div className="text-left border p-3 rounded-md">
                <div className="bg-gray-100 p-2 w-full relative">
                  <div className="flex gap-3 mb-5">
                    <div class="relative inline-flex items-center justify-center bg-blue-500 w-24 h-24 overflow-hidde  rounded-full">
                      <span class="font-medium text-white text-center p-4">
                        {moment(
                          selectedNotificationData?.Alert?.created
                        ).format("dddd Do MMM")}
                      </span>
                    </div>
                    <div>
                      <p className="text-base font-bold mb-1 mt-4">
                        {selectedNotificationData?.Alert?.message}
                      </p>
                      <span className="text-gray-500 text-base">
                        {" "}
                        {selectedNotificationData?.Alert?.sender_name}{" "}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-2 absolute right-3 bottom-2">
                    <i>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                    </i>
                    <span className="text-sm font-normal text-gray-600">
                      {formattedTime}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <p>No record found.</p>
      )}
    </>
  );
}

export default Notifications;
